export default __webpack_public_path__ + "9f78a9a8e2adb255926ed790268f6dca.png";